import { render } from "./Update.vue?vue&type=template&id=cf36b47e&scoped=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"

import "./Update.vue?vue&type=style&index=0&id=cf36b47e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-cf36b47e"

export default script